/**
 * Форма создания платежа (точечное погашение)
 */

import React from 'react';
import { Formik, Form } from 'formik';
import { TextInput } from '../../../components/UI/FormItems';
import { useCreatePayment } from '../../../hooks/useAdmin';
import { createPaymentSchema } from '../validation/schemas';
import type { PaymentParams } from '../../../types';

interface CreatePaymentFormValues {
  sum: string;
  date: string;
}

interface CreatePaymentFormComponentProps {
  creditContractId: number | null;
  selectedClientName: string;
}

/**
 * Компонент формы точечного погашения
 */
export const CreatePaymentFormComponent: React.FC<CreatePaymentFormComponentProps> = ({
  creditContractId,
  selectedClientName,
}) => {
  const createPaymentMutation = useCreatePayment();

  const initialValues: CreatePaymentFormValues = {
    sum: '',
    date: '',
  };

  const handleSubmit = async (values: CreatePaymentFormValues, { resetForm, setSubmitting }: { resetForm: () => void; setSubmitting: (v: boolean) => void }) => {
    const sum = Number(values.sum);
    if (!creditContractId || !sum || !values.date) {
      setSubmitting(false);
      return;
    }

    const params: PaymentParams = {
      creditContractId,
      sum,
      date: values.date,
    };

    try {
      await createPaymentMutation.mutateAsync(params);
      resetForm();
    } catch (error) {
      // Ошибка уже обработана в onError хука
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <fieldset>
      <Formik
        key={creditContractId || 'no-client'}
        initialValues={initialValues}
        validationSchema={createPaymentSchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <div style={{ display: 'table' }}>
              <div style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                Точечное погашение досрочное/плановое/просроченное по клиенту
              </div>
              {selectedClientName && (
                <div style={{ marginLeft: '10px', fontSize: '14px', color: '#666' }}>
                  Клиент: {selectedClientName}
                </div>
              )}
              <div style={{ marginTop: '20px' }} />

              <TextInput type="date" name="date" label="Дата: " />
              <TextInput label="Сумма: " name="sum" placeholder="0.00" />

              <button
                className="btn"
                type="submit"
                disabled={createPaymentMutation.isPending || !creditContractId}
                style={{ marginLeft: '10px' }}
              >
                {createPaymentMutation.isPending
                  ? 'Отправка...'
                  : 'Отправить запрос в ИБСО'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </fieldset>
  );
};
